import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { TextField } from '@material-ui/core';
import { trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

import ContentEmailAddress from './elements/ContentEmailAddress';
import ContentEmailSubject from './elements/ContentEmailSubject';
import ContentMailBody from './elements/ContentMailBody';
import ContentEmailCheckboxDeliver from './elements/ContentEmailCheckboxDeliver';
import ContentEmailAttachment from './elements/ContentEmailAttachment';
import { useEffect } from 'react';
import { PropTypes } from 'prop-types';

ContentCurrentEmailTicket.propTypes = {
    setIsSelectDeliver: PropTypes.any,
};

export default function ContentCurrentEmailTicket({
    originTicket,
    currentEmailTicket,
    displayMode,
    onclickReplyTicket,
    currentTicketDeliverStatus,
    setCurrentTicketDeliverStatus,
    isEditedCurrentTicket,
    setIsEditedCurrentTicket,
    setIsShowPopupLogout,

    isDisableEdit,

    currentTicketFields,

    toEmailAddressList,
    setToEmailAddressList,
    ccEmailAddressList,
    setCcEmailAddressList,
    bccEmailAddressList,
    setBccEmailAddressList,
    listSuggestSearchEmail,

    currentMailSubject,
    setCurrentMailSubject,
    
    currentMailBody,
    setCurrentMailBody,

    fileUploadList,
    setFileUploadList,
    fileUpdatedList,
    setFileUpdatedList,
    fileDeletedList,
    setFileDeletedList,
    currentAttachmentError,
    setCurrentAttachmentError,

    triggerEnableBtnSaveTicket,
    isTriggerReloadCurrentTicket,
    setIsSelectDeliver
}) {
    // Re-render when the translation dictionary loads/extends so trLabel() text updates.
    useTranslationSubscription();

    let isCustomerMail = currentEmailTicket?.projectOrigin !== currentEmailTicket?.affiliationProject;
    let isDeliverTicket = currentEmailTicket?.ticketType === Constant.TICKET_TYPE.EMAIL ||
        (currentEmailTicket?.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY && currentEmailTicket?.deliverInfo?.status)
    let isDisableLink = originTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED || !Utils.isEmptyString(originTicket.deletedAt);
    // Validate value field to Trigger Enable Btn Save Ticket
    useEffect(() => {
        if (!isEditedCurrentTicket) return;
        triggerEnableBtnSaveTicket()
    }, [
        isEditedCurrentTicket,
        toEmailAddressList,
        ccEmailAddressList,
        bccEmailAddressList,
        currentMailSubject,
        currentMailBody,
        fileUploadList,
        fileUpdatedList,
        fileDeletedList
    ])

    return (
        <div className="addTicket addTicket-detail footer">
            {currentTicketFields.map((fieldData, i) => {
                    switch (fieldData.sysField) {
                        case Constant.SYS_FIELD.FROM:
                            return (
                                <div className='form-addTicket'>
                                    <div className="cell-prod-status gap-8"><label class="form-addTicket-label">{trLabel(fieldData?.name?.jp?.text)}</label></div>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        className="form-control-wrapInput form-control-hg40 email-response-address-input"
                                        inputProps={{style: {color: '#2E3138' }}}
                                        value={Utils.isEmptyObject(fieldData.value) ? '' : fieldData.value }
                                        disabled={true}
                                    />
                                </div>
                            );
                        case Constant.SYS_FIELD.TO:
                        case Constant.SYS_FIELD.CC:
                        case Constant.SYS_FIELD.BCC:
                            return (
                                <ContentEmailAddress
                                    fieldData={fieldData}
                                    address={(() => {
                                        switch (fieldData.sysField) {
                                            case Constant.SYS_FIELD.TO:
                                                return toEmailAddressList
                                            case Constant.SYS_FIELD.CC:
                                                return ccEmailAddressList
                                            case Constant.SYS_FIELD.BCC:
                                                return bccEmailAddressList
                                            default:
                                                return [];
                                        }
                                    })()}
                                    setAddress={(() => {
                                        switch (fieldData.sysField) {
                                            case Constant.SYS_FIELD.TO:
                                                return setToEmailAddressList
                                            case Constant.SYS_FIELD.CC:
                                                return setCcEmailAddressList
                                            case Constant.SYS_FIELD.BCC:
                                                return setBccEmailAddressList
                                            default:
                                                return () => {};
                                        }
                                    })()}
                                    listSuggestSearchEmail={listSuggestSearchEmail}
                                    disabled={isCustomerMail || isDeliverTicket || isDisableLink || isDisableEdit}
                                    required={fieldData.sysField === Constant.SYS_FIELD.TO}
                                    isEditedCurrentTicket={isEditedCurrentTicket}
                                    setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                />
                            );
                        case Constant.SYS_FIELD.MAIL_SUBJECT:
                            return (
                                <ContentEmailSubject
                                    fieldData={fieldData}
                                    disabled={isCustomerMail || isDeliverTicket || isDisableLink || isDisableEdit}
                                    setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                    currentMailSubject={currentMailSubject}
                                    setCurrentMailSubject={setCurrentMailSubject}
                                    contentId={currentEmailTicket?.id}
                                    displayMode={displayMode}
                                />
                            );
                        case Constant.SYS_FIELD.MAIL_BODY:
                            return (
                                <>
                                    <ContentMailBody
                                        fieldData={fieldData}
                                        isCustomerMail={isCustomerMail}
                                        isDeliverTicket={isDeliverTicket}
                                        isDisableLink={isDisableLink}
                                        isDisableEdit={isDisableEdit || isDisableLink}
                                        onclickReplyTicket={onclickReplyTicket}
                                        setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                        currentMailBody={currentMailBody}
                                        setCurrentMailBody={setCurrentMailBody}
                                        contentId={currentEmailTicket?.id}
                                        displayMode={displayMode}
                                    />
                                    <ContentEmailCheckboxDeliver
                                        currentEmailTicket={currentEmailTicket}
                                        currentTicketDeliverStatus={currentTicketDeliverStatus}
                                        setCurrentTicketDeliverStatus={setCurrentTicketDeliverStatus}
                                        setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                        originTicket={originTicket}
                                        isDisableEdit={isDisableEdit}
                                        setIsSelectDeliver={setIsSelectDeliver}
                                    />
                                </>
                            );
                        case Constant.SYS_FIELD.ATTACHMENTS:
                            return (
                                <ContentEmailAttachment
                                    detailTicket={originTicket}
                                    currentEmailTicket={currentEmailTicket}
                                    setIsShowPopupLogout={setIsShowPopupLogout}

                                    fieldData={{
                                        ...fieldData,
                                        value: fieldData.value.map(f => ({
                                            ...f,
                                            file: {name: f.fileName, size: f.fileSize, url: f.fileUrl},
                                            thumbnailInfo: {
                                                small: {size: f.size,thumbnailUri: f.url},
                                                large: {size: f.size,thumbnailUri: f.url},
                                                medium: {size: f.size,thumbnailUri: f.url}
                                            },
                                        }))
                                    }}
                                    isUnDeliverTicket={!isCustomerMail && !isDeliverTicket}

                                    fileUploadList={fileUploadList}
                                    setFileUploadList={setFileUploadList}
                                    fileUpdatedList={fileUpdatedList}
                                    setFileUpdatedList={setFileUpdatedList}
                                    fileDeletedList={fileDeletedList}
                                    setFileDeletedList={setFileDeletedList}
                                    currentAttachmentError={currentAttachmentError}
                                    setCurrentAttachmentError={setCurrentAttachmentError}

                                    setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                    isDisableEdit={isDisableEdit}
                                    isTriggerReloadCurrentTicket={isTriggerReloadCurrentTicket}
                                />
                            );
                        default:
                            return <></>
                    }
                })
            }
        </div>
    );
}
